import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Star } from "lucide-react";

// Note et volume d'avis vs concurrents suivis — uniquement les valeurs observées dans Google (pas d'estimation).
export const GoogleCompetitorReviews = ({ estId }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/google/competitor-reviews/${estId}`).then((r) => setD(r.data)).catch(() => setD(null)); }, [estId]);
  if (!d) return null;
  const fmt = (v) => (v == null ? "—" : String(v.toFixed ? v.toFixed(1) : v).replace(".", ","));
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 text-sm space-y-3" data-testid="gbp-competitor-reviews">
      <h3 className="font-heading font-bold flex items-center gap-2"><Star className="w-4 h-4 text-amber-500" /> Vos avis face aux concurrents suivis</h3>
      {!d.available ? <p className="text-slate-500" data-testid="gbp-competitors-empty">Comparatif disponible dès que votre fiche Google est synchronisée et que des concurrents suivis ont une note observée dans Google.</p> : <>
        {d.facts.map((f, i) => <p key={i} className="text-slate-700" data-testid={`gbp-comp-fact-${i}`}>{f}</p>)}
        <table className="w-full text-xs">
          <thead><tr className="text-slate-500 text-left"><th className="py-1">Établissement</th><th>Note</th><th>Avis</th><th className="hidden sm:table-cell">Source</th></tr></thead>
          <tbody>
            <tr className="font-semibold bg-blue-50"><td className="py-1.5 pl-1">{d.me.name} (vous)</td><td>{fmt(d.me.rating)}/5</td><td>{d.me.reviews_count ?? "—"}</td><td className="hidden sm:table-cell text-slate-500">{d.me.source || "—"}</td></tr>
            {d.competitors.map((c, i) => <tr key={i} className="border-t border-slate-100" data-testid={`gbp-comp-row-${i}`}><td className="py-1.5 pl-1">{c.name}</td><td>{c.available ? `${fmt(c.rating)}/5` : "—"}</td><td>{c.reviews_count ?? "—"}</td><td className="hidden sm:table-cell text-slate-500">{c.source || c.note}</td></tr>)}
          </tbody>
        </table>
        <p className="text-xs text-slate-400">{d.note}</p>
      </>}
    </div>
  );
};
